/**
 * 그림자 토큰 — teal 틴트를 포함한 부드러운 그림자
 */

export const shadows = {
  soft: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 1px 8px rgba(20,184,166,0.08)',
    lg: '0 4px 24px rgba(20,184,166,0.12)',
    xl: '0 8px 40px rgba(20,184,166,0.16)',
  } as const,
} as const

export type ShadowKey = keyof typeof shadows.soft

export const getShadowClass = (level: ShadowKey) =>
  `shadow-soft-${level}` as const
